import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import horasService from '../services/horasService';

const initialState = {
  error: false,
  success: false,
  loading: false,
  successPost:false,
  loadingPost:false,
  funcionarios: [],
  justificativaPadrao: null,
};

export const getFuncionarios = createAsyncThunk(
  'horas/funcionarios',
  async (_, thunkAPI) => {
    const response = await horasService.funcionarios();
    if (response.errors) {
      return thunkAPI.rejectWithValue(response.errors);
    }
    return response;
  }
);

export const getJustificativaPadrao = createAsyncThunk(
  'horas/justificativaPadrao',
  async (_, thunkAPI) => {
    const response = await horasService.justificativaPadrao();
    if (response.errors) {
      return thunkAPI.rejectWithValue(response.errors);
    }
    return response;
  }
);


// export const postHorasExtra = createAsyncThunk(
//   'horas/postHorasExtra',
//   async (data, thunkAPI) => {
//     const response = await horasService.postHorasExtra(data);
//     if (response.errors) {
//       console.log(response.errors)
//       return thunkAPI.rejectWithValue(response.errors);
//     }
//     return response.data;
//   }
// );


export const postHorasExtra = createAsyncThunk(
  'horas/postHorasExtra',
  async (data, thunkAPI) => {
    const response = await horasService.postHorasExtra(data);
    if (response.errors) {
      return thunkAPI.rejectWithValue(response.errors);
    }
    // Retorna o pdf na pagina
    const url = window.URL.createObjectURL(new Blob([response], { type: 'application/pdf' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `Formulario.pdf`);
    document.body.appendChild(link);
    link.click();

    return true;

  }
);

export function extrairMensagensErro(errors) {
  // Caso errors seja null ou undefined, retorne uma mensagem genérica
  // Etraindo msg do backend, caso seja um array de erros ou um objeto com non_field_errors
  if (!errors) return "Erro desconhecido.";

  let mensagens = [];

  if (Array.isArray(errors)) {
    mensagens = errors.flatMap(item =>
      item?.non_field_errors ?? []
    );
  } else if (errors.non_field_errors) {
    mensagens = errors.non_field_errors;
  } else if (typeof errors === "string") {
    mensagens = [errors];
  }

  if (!mensagens.length) {
    return "Erro ao processar requisição.";
  }

  // Regex para detectar datas no formato ISO (YYYY-MM-DD)
  const regexDataISO = /\d{4}-\d{2}-\d{2}/g;

  return mensagens
    .map(msg =>
      msg.replace(regexDataISO, (dataISO) => {
        const [ano, mes, dia] = dataISO.split("-");
        return `${dia}/${mes}/${ano}`;
      })
    )
    .join("\n");
}


export const horasSlice = createSlice({
  name: 'horas',
  initialState,
  reducers: {
    resetOut: (state) => {
      state.loading = false;
      state.error = false;
      state.success = false;
      state.successPost = false;
      state.loadingPost = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFuncionarios.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getFuncionarios.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.funcionarios = action.payload;
      })
      .addCase(getFuncionarios.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.success = false;
      })
    .addCase(getJustificativaPadrao.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getJustificativaPadrao.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.justificativaPadrao = action.payload;
      })
      .addCase(getJustificativaPadrao.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
            state.success = false;
        })
      .addCase(postHorasExtra.pending, (state) => {
        state.loadingPost = true;
        state.error = null;
      })
      .addCase(postHorasExtra.fulfilled, (state, action) => {
        state.loadingPost = false;
        state.successPost = true;
        // state.justificativaPadrao = action.payload;
      })
      .addCase(postHorasExtra.rejected, (state, action) => {
          const mensagem = extrairMensagensErro(action.payload);
          state.loadingPost = false;
          state.error = mensagem;
          state.successPost = false;
        })
        
  },
});

export const { resetOut } = horasSlice.actions;
export default horasSlice.reducer;
